import './ticket_count_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.OperationCurrentStatusChartView extends CustomerVisualMode.Charts.TicketCountChartView
  template: JST['backbone/templates/customer_visual_mode/charts/operation_current_status_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'operation_current_status'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.operation_current_status.title')
    description = I18n.t('customer_visual_mode.charts.operation_current_status.description')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html @template
    @_ticketCountCardViews().forEach (view) =>
      @$('.operation-current-status-chart').append(
        view.render().el
      )
    @

  _ticketCountCardViews: ->
    [
      @_pendingAttentionTicketsView()
      @_inAttentionTicketsView()
      @_waitingForAnAnswerTicketsView()
    ]
